import { Blf } from './blf';
import { RegistrationStates } from './enums/registration-states';

export class Device {
    public address: string;
    public name: string;
    public manufacturer: string;
    public modelName: string;
    public organizationId: string;
    public data: string = '';
    public extensionIds: string[] = [];
    public password: string;
    public rport: number = 2;
    public vlanId: number = 0;
    public codecs: string[] = [];
    public state: RegistrationStates;
    public registrationTime: Date;
    public unregistrationTime: Date;
    public publicAddress: string;
    public privateAddress: string;
    public stun: boolean = false;
    public stunServer: string;
    public stunPort: number = 3478;
    public blfs: Blf[] = [];
    public extenders: Blf[] = [];
}
